<template>
  <button type="button" :class="cls">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    color: {
      default: 'primary'
    },
    rounded: {
      default: 'rounded-md'
    }
  },
  computed: {
    cls() {
      let cls = {
        'inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:z-10': true,
        'text-primary-700 bg-primary-100 hover:bg-primary-200 focus:ring-primary-500': this.color === 'primary',
        'text-red-700 bg-red-100 hover:bg-red-200 focus:ring-red-500': this.color === 'red',
        'text-green-700 bg-green-100 hover:bg-green-200 focus:ring-green-500': this.color === 'green',
        'text-orange-700 bg-orange-100 hover:bg-orange-200 focus:ring-orange-500': this.color === 'orange',
        'text-yellow-700 bg-yellow-100 hover:bg-yellow-200 focus:ring-yellow-500': this.color === 'yellow',
        'text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:ring-indigo-500': this.color === 'indigo',
      }
      cls[this.rounded] = true
      return cls
    }
  }
}
</script>X

<style scoped>

</style>